import React, { useContext, useState } from "react";
import { GlobalContext } from '../../contexts/GlobalContext';
import { white, grayScale } from './../../theme/colors'
import PageTitle from "../../components/PageTitle/PageTitle";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import MainQuestions from "../../components/MainQuestions/MainQuestions";
import InputGroup from "../../components/Form/InputGroup";
import states from '../../lists/states.json';
import './FrequentlyAsked.css'
import SelectGroup from "../../components/Form/SelectGroup";
import Btn from "../../components/Btn/Btn";
 

const FrequentlyAsked = () => {

    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const [personState, setPersonState] = useState('');

    const data = require(`../../assets/languages/${language}/frequentlyAsked.json`);
    const {
        breadcrumb,
        pageTitle,
        pageSubtitle,
        selectedPage,
        formTitle,
        formSubtitle,
        form
    } = data

    const {
        formName,
        formEmail,
        formCompany,
        formCountry,
        formState,
        formCelPhone,
        formPhone,
        formMensage,
        formPolicy,
        formBtn
    } = form


    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
            />
            <div className="main-container">
                <div className="section-container">
                    <PageTitle title={pageTitle} subtitle={pageSubtitle} />
                    <MainQuestions backgroundColorContent={white} contentColor={grayScale.gray300} hideBtn={true} />
                </div>
                <div className="section-container d-none">
                    <PageTitle title={formTitle} subtitle={formSubtitle} />
                    <div className="relprev-form-container">
                        <form action="">
                            <div className="_form-row">
                                <InputGroup
                                    id={formName.id}
                                    inputName={formName.name}
                                    label={formName.label}
                                    disable={null}
                                    inputType={formName.type}
                                    value={null}
                                    errorMsg={null}
                                    _function={null}
                                    className="default-form-1"
                                />

                                <InputGroup
                                    id={formEmail.id}
                                    inputName={formEmail.name}
                                    label={formEmail.label}
                                    disable={null}
                                    inputType={formName.type}
                                    value={null}
                                    errorMsg={null}
                                    _function={null}
                                    className="default-form-1"

                                />

                                <InputGroup
                                    id={formCompany.id}
                                    inputName={formCompany.name}
                                    label={formCompany.label}
                                    disable={null}
                                    inputType={formCompany.type}
                                    value={null}
                                    errorMsg={null}
                                    _function={null}
                                    className="default-form-1 mg-top-30"

                                />

                                <InputGroup
                                    id={formCountry.id}
                                    inputName={formCountry.name}
                                    label={formCountry.label}
                                    disable={null}
                                    inputType={formCountry.type}
                                    value={null}
                                    errorMsg={null}
                                    _function={null}
                                    className="default-form-2 mg-top-30"
                                />

                                <SelectGroup
                                    id={formState.id}
                                    inputName={formState.name}
                                    label={formState.label}
                                    disable={null}
                                    inputType={formState.type}
                                    value={personState}
                                    errorMsg={null}
                                    _function={(val) => {
                                        setPersonState(val);
                                    }}
                                    options={states}
                                    className="default-form-3 mg-top-30"
                                />

                                <InputGroup
                                    id={formCelPhone.id}
                                    inputName={formCelPhone.name}
                                    label={formCelPhone.label}
                                    disable={null}
                                    inputType={formCelPhone.type}
                                    value={null}
                                    errorMsg={null}
                                    _function={null}
                                    className="default-form-1 mg-top-30"

                                />

                                <InputGroup
                                    id={formPhone.id}
                                    inputName={formPhone.name}
                                    label={formPhone.label}
                                    disable={null}
                                    inputType={formPhone.type}
                                    value={null}
                                    errorMsg={null}
                                    _function={null}
                                    className="default-form-1 mg-top-30"

                                />

                                <InputGroup
                                    id={formMensage.id}
                                    inputName={formMensage.name}
                                    label={formMensage.label}
                                    disable={null}
                                    inputType={formMensage.type}
                                    value={null}
                                    errorMsg={null}
                                    _function={null}
                                    isTextArea={true}
                                    placeholder={'Escreva brevemente sua solicitação'}
                                    className="w-100 mg-bot-50 mg-top-30"
                                />
                            </div>
                        </form>
                    </div>
                    <div className="mg-bot-100">
                        <div className="container-privacy-term">
                            <div className="content-privacy-term">
                                <input
                                    type="checkbox"
                                    id={null}
                                    name={null}
                                    checked={null}
                                    disabled={null}
                                    onChange={null}
                                    className="_checkbox"
                                />
                                <label htmlFor={formPolicy.id} dangerouslySetInnerHTML={{ __html: formPolicy.label }} className="mg-l-10">
                                </label>
                            </div>
                            <Btn
                                label={formBtn.label}
                                disabled={true}
                                className="relprev-form-btn"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FrequentlyAsked;